<template>
  <DBox
    :id="'cmp-distribution-supplier-order-orderlines'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('')}`"
    @add_click="onAddClick"
  >
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="catalog-releases-artist"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:thead="{ thcon, thtext }">
        <tr style="color: var(--text-5)">
          <th v-bind="thcon('catalogue_no')">
            <div class="ut-fc">
              <span>Catalog No.</span>
              <span>Barcode</span>
            </div>
          </th>
          <th v-bind="thcon('artist')">
            <div class="ut-fc">
              <span>Artist</span>
              <span>Title</span>
            </div>
          </th>
          <th v-bind="thcon('format')">
            <div class="ut-fc">
              <span>Label</span>
              <span>Format</span>
            </div>
          </th>


          <th style="text-align:right" v-bind="thcon('qty')">
            <span>Quantity</span>
          </th>
          <th style="text-align:right" v-bind="thcon('ppu')">
            <span>PPU</span>
          </th>
          <th  style="text-align:right" v-bind="thcon('shortfall')">
            <span>Shortfall</span>
          </th>
          <th v-bind="thcon('foc')">
            <span>foc</span>
          </th>
          <th v-bind="thcon('final_qty')">
            <span>{{thtext('final_qty')}}</span>
          </th>
          <th v-bind="thcon('total')">
            <span>total</span>
          </th>
          <th v-bind="thcon('option')"></th>
        </tr>
      </template>
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('catalogue_no')">
            <div class="ut-flex">
              <div class="circular-status">
                <div 
                  class="circular-status-color"
                  style="
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    margin-right: 8px;
                  "
                      :style="{
                        'background-color': `#${item['label_status_colour']}`,
                        border: item['label_status_colour']
                          ? `1px solid #${item['label_status_colour']}`
                          : '1px solid gray',
                      }"
                    ></div>
                  </div>

                  <div class="ut-fc ut-txtov">
                    <span class="ut-txtov" :title="item['catalog_no']">{{
                      item["catalog_no"]
                    }}</span>
                    <span class="ut-txtov" :title="item['barcode']">{{
                      item["barcode"]
                    }}</span>
                  </div>
                </div>
           
          </td>
          <td v-bind="tdcon('artist')">
            <div class="ut-fc ut-txtov">
              <span class="ut-txtov" :title="item['release_alt_artist']">
                {{item["release_alt_artist"]}}
              </span>
              <span class="ut-txtov" :title="item['release_alt_title']">
                {{item["release_alt_title"]}}
              </span>
            </div>
          </td>

          <td v-bind="tdcon('format')">
            <div class="ut-fc ut-txtov">
              <span class="ut-txtov" :title="item['label_name']">
                {{item["label_name"]}}
              </span>
              <span class="ut-txtov" :title="item['format_name']">
                {{item["format_name"]}}
              </span>
            </div>
          </td>
          <td v-bind="tdcon('qty')">
            <TextField2
              type="text"
              :ta="'right'"
              class="dbox1"
              id="order_qty"
              :showLabel="false"
              :disabled="false"
              :value="item['order_qty']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>

          <td v-bind="tdcon('ppu')">
            <TextField2
              type="text"
              :ta="'right'"
              class="dbox1"
              id="ppu"
              :showLabel="false"
              :disabled="false"
              :value="item['ppu']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('shortfall')">
            <TextField2
              type="text"
               :ta="'right'"
              class="dbox1"
              id="shortfall_qty"
              :showLabel="false"
              :disabled="false"
              :value="item['shortfall_qty']"
              :bb="'0px'"
              @change="e => onTextFieldChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('foc')">
             <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1 ">
                <input
                  class="disabled"
                  type="checkbox"
                  :name="'promo'"
                  :id="'promo'"
                  :checked="item['promo']==1"
                  @click="e => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
          <td v-bind="tdcon('final_qty')">
            <span>{{ item["final_qty"] }}</span>
          </td>
          <td v-bind="tdcon('total')">
            <span>{{ item["value"] }}</span>
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteOrderLine(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV, tv } from "../../../../models/text-value.model";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { catalogArtistListLDTRoutes } from '../../router/routes';
export default {
  props: {
    selectedSupplierOrderDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        headerHeight: 52,
        rowHeight: 52,
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("catalogue_no", {}),
        createTableHeader("artist", {}),
        //createTableHeader("title1", { text:'Title' }),
        createTableHeader("format",{}),
        createTableHeader("qty",{ ta:'right', mw:80}),
        createTableHeader("ppu",{ ta:'right',mw:65}),
        createTableHeader("shortfall",{mw:65}),
        createTableHeader("foc",{ mw:40}),
        createTableHeader("final_qty",{ ta:'right' ,mw:65}),
        createTableHeader("total",{ta:'right',mw:65}),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedSupplierOrderDetails.orderlines || [];
    },

    accountTV: function() {
      return createTV(this.selectedSupplierOrderDetails?.accounts||[],'account_name','account_id');
    },
    supplier_id:function(){
      return this.selectedSupplierOrderDetails?.so?.supplier_id
    }

  },
  methods: {
    onTextFieldChange: function(e, item) {
      const payload = {
        name: e.name,
        value: e.value,
        kVal:item.supplier_orderline_id,
        objKey:'orderlines'
        //item: item
      };
      this.$emit("change", payload);

      console.log("ARTIST", payload, e);
    },

    onAddClick: function() {
      //this.$emit('add')
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_order_line_modal",
          supplier_order_id:this.selectedSupplierOrderDetails.supplier_order.supplier_order_id,
          so_product:false,
          supplier_id:this.supplier_id
        }
      });
    },
    deleteOrderLine: async function(item) {
      const confirmationResult = await confirmDelete(
        this.$t("delete_orderline_msg"),
        ''
      );
      if (confirmationResult == "OK") {
        // const payload = { relation_id: item.relation_id };
        this.$emit("delete", {item,objKey:'orderlines' });
      }
    },
  }
};
</script>
